<template>
  <div style="padding:0 20px">
    <treeRender
      :list="treeData"
      :level="0"
      :selected="selected"
      :call-back="callBack"
      :have-extra-button="haveExtraButton"
    />
  </div>
</template>
<script>
  import treeRender from './components/treeRender.vue'
  export default {
    components: {
      treeRender
    },
    props:{
      treeData:{
        type:Array,
        default:() => []
      },
      render: {
        type: Function,
        default:() => []
      },
      treeCallBackObj: {
        type: Object,
        default: () => {}
      },
      haveExtraButton:{
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected:null
      }
    },
    computed: {
      callBack() {
        return {
          changeSelected: this.changeSelected,
          ...this.treeCallBackObj
        }
      },
    },
    methods: {
      changeSelected(item) {
        const { selectedItem = () => {} } = this.treeCallBackObj
        this.selected = item.id
        selectedItem(item)
      }
    },
  }
</script>
